import {CorrespondenceType} from "../../definitions/types";

export class CorrespondenceModel {
    private readonly _id: number;
    private readonly _title: string;
    private readonly _path: string;
    private readonly _sort: number;

    constructor(public readonly correspondence: CorrespondenceType) {
        this._id = correspondence.id;
        this._title = correspondence.title;
        this._path = correspondence.path;
        this._sort = correspondence.sort;
    }

    /**
     * @method id
     * @description Returns the id of the correspondence item.
     * @returns {number}
     */
    public get id(): number {
        return this._id;
    }

    /**
     * @method title
     * @description Returns the title of the correspondence item.
     * @returns {string}
     */
    public get title(): string {
        return this._title;
    }

    /**
     * @method path
     * @description Returns the path to the correspondence item.
     * @returns {string}
     */
    public get path(): string {
        return this._path;
    }

    /**
     * @method sort
     * @description Returns the sort order of the correspondence item with respect to the associated product.
     * @returns {number}
     */
    public get sort(): number {
        return this._sort;
    }
}